import React from 'react'
import { Box, Chip, Paper, Typography } from '@mui/material'
import AssignmentIcon from '@mui/icons-material/Assignment'
import HomeWorkIcon from '@mui/icons-material/HomeWork'
import DescriptionIcon from '@mui/icons-material/Description'
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser'

import { ProcessStatus, ProcessStage } from '../../types/leasingContext'

interface ApplicantProcessCardProps {
    status: ProcessStatus
}

const STAGE_ICON: Record<ProcessStage, typeof AssignmentIcon> = {
    application: AssignmentIcon,
    screening: VerifiedUserIcon,
    lease: DescriptionIcon,
    move_in: HomeWorkIcon,
}

export const ApplicantProcessCard: React.FC<ApplicantProcessCardProps> = ({
    status,
}) => {
    const waitingOnYou = status.waiting_on === 'you'
    const Icon = STAGE_ICON[status.stage] ?? AssignmentIcon

    return (
        <Paper
            sx={{
                p: 3,
                mb: 3,
                backgroundColor: '#2a2f35',
                border: '1px solid',
                borderColor: waitingOnYou ? '#46b083' : 'grey.700',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 1,
                    mb: 1,
                    flexWrap: 'wrap',
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Icon sx={{ color: '#46b083' }} />
                    <Typography
                        variant="h6"
                        sx={{ color: '#fff', fontWeight: 600 }}
                    >
                        {status.headline}
                    </Typography>
                </Box>
                <Chip
                    label={waitingOnYou ? 'Waiting on you' : 'Waiting on us'}
                    size="small"
                    sx={
                        waitingOnYou
                            ? {
                                  backgroundColor: 'rgba(70, 176, 131, 0.2)',
                                  color: '#46b083',
                                  fontWeight: 600,
                              }
                            : {
                                  backgroundColor: 'rgba(139, 148, 158, 0.16)',
                                  color: '#8b949e',
                                  fontWeight: 600,
                              }
                    }
                />
            </Box>

            <Box
                sx={{
                    display: 'flex',
                    gap: 1,
                    mb: 2,
                    flexWrap: 'wrap',
                }}
            >
                {status.steps.map((step, index) => (
                    <Typography
                        key={step.id}
                        variant="caption"
                        sx={{
                            color:
                                step.state === 'current'
                                    ? '#fff'
                                    : step.state === 'complete'
                                      ? '#46b083'
                                      : '#8b949e',
                            fontWeight: step.state === 'current' ? 700 : 500,
                        }}
                    >
                        {step.label}
                        {index < status.steps.length - 1 ? '  →  ' : ''}
                    </Typography>
                ))}
            </Box>

            <Typography variant="body2" sx={{ color: '#8b949e' }}>
                {status.detail}
            </Typography>
        </Paper>
    )
}
